export default __webpack_public_path__ + "static/media/093-resize-2.217e0d9d.png";